import React from 'react'
import { Table } from 'reactstrap'
import moment from 'moment'
import InfoTooltip from '../Common/InfoTooltip'

export default ({ holidays }) => (
  <Table>
    <tbody>
    {holidays.map(holiday => (
        <tr key={holiday.id}>
          <td>
            {holiday.title} &nbsp;
            {holiday.description && <InfoTooltip text={holiday.description} position="right"/>}
          </td>
          <td>{moment(holiday.date).format('DD.MM.YYYY')}</td>
        </tr>
      )
    )}
    </tbody>
  </Table>
)
